const keys = { 'A': 0, 'Bb': 1, 'A#': 1, 'B': 2, 'Cb': 2, 'C': 3, 'B#': 3, 'C#': 4, 'Db': 4, 'D': 5, 'D#': 6, 'Eb': 6, 'E': 7, 'E#': 8, 'Fb': 7, 'F': 8, 'F#': 9, 'Gb': 9, 'G': 10, 'G#': 11, 'Ab': 11 };
const keysSharp = ['A', 'A#', 'B', 'C', 'C#', 'D', 'D#', 'E', 'F', 'F#', 'G', 'G#', 'A'];
const keysFlat = ['A', 'Bb', 'B', 'C', 'Db', 'D', 'Eb', 'E', 'F', 'Gb', 'G', 'Ab', 'A'];


export default class TestModule {
  constructor(el) {
    
      const setKey = el.querySelector('[data-set-key]')
      const keyDown = el.querySelector('[data-key-down]')
      const keyUp = el.querySelector('[data-key-up]')
      let keyValue = el.querySelector('[data-key-value]')
      let keyFlat= el.querySelector('[data-key-flat]')
      
      let preProcess = el.querySelector('[data-pre-process]');
      let postProcess = el.querySelector('[data-post-process]');
    
      const absoluteKey = keys[setKey.innerText];
    
      function processText(pretarget, posttarget) {
        let pre = pretarget.innerHTML, //Grab values
          prearray = [],
          postarray = [],
          postprocessed = '',
          absKey = keys[absoluteKey];
    
    
        //Split into lines,
        prearray = pre.split('\n');
    
        //iterate over lines
        for (let line in prearray) {
          //Get text
          let text = prearray[line].replace(/ /g, "&nbsp;");
    
          //Eval linetype
          let type = 'base';
          if (text.indexOf('&nbsp;&nbsp;') > -1) {
            type = 'chords';
          }
          if (text.indexOf('Verse') > -1 || text.indexOf('VERSE') > -1 || text.indexOf('verse') > -1 || text.indexOf('Chorus') > -1 || text.indexOf('CHORUS') > -1 || text.indexOf('chorus') > -1 || text.indexOf('Bridge') > -1 || text.indexOf('BRIDGE') > -1 || text.indexOf('bridge') > -1 || text.indexOf('Intro') > -1 || text.indexOf('intro') > -1 || text.indexOf('INTRO') > -1) {
            type = 'title';
          }
          let preLine;
          var elToAdd = document.createElement('div');
          elToAdd.classList.add('chords__line');
          
          if (type == 'title') {
            elToAdd.classList.add('chords__title');
            elToAdd.innerHTML = text;
          }
          else if (type != 'chords') {
            elToAdd.classList.add('chords__lyrics');
            elToAdd.innerHTML = text;
          }
          
          else {
            elToAdd.classList.add('chords__chords');
            elToAdd.innerHTML = text;
    
    
            //regex to find array of chord values
            let chordArray;
            const chordRegex = RegExp('[A-G]b?\#?', 'g')
            while ((chordArray = chordRegex.exec(text)) !== null) {
              for (let i in chordArray) {
                  
                let chordText = chordArray[0];
                let keyValue = keys[chordText];
                let keyRel = keyValue - absoluteKey;
                if (keyRel < 0) {
                  keyRel += 12;
                }
                let chordProcessed = '';
                chordProcessed = '<span class="chord-item" data-chordval="' + keyRel + '"></span>';
              
                let oldHTML = elToAdd.innerHTML;
                let newHTML = oldHTML.replace(chordText, chordProcessed);
                elToAdd.innerHTML = newHTML;
              }
            }
          }
          posttarget.append(elToAdd);
    
        }
    
        pretarget.parentNode.removeChild(pretarget);
        renderChords();
      }
    
    
      function renderChords(keyNumber) {
    
        //Get current key value
    
        let keyMod = keyNumber;
        if (keyMod == undefined) {
          keyMod = keys[setKey.innerText];
        }
        if (keyMod < 0) {
          keyMod += 12;
        }
        //Get key array
        let arrayToUse = keysSharp;
        if (keyFlat.getAttribute('checked') == true || keyFlat.getAttribute('checked') == 'true') {
          arrayToUse = keysFlat;
        }
    
        let chordItems = el.querySelectorAll('.chord-item');
        if (chordItems) {
          chordItems.forEach(el=> {
            let specificValue = el.getAttribute('data-chordval') + keyMod;
            if (specificValue > 0) {
              specificValue = specificValue % 12;
            }
            
            el.innerText = arrayToUse[parseInt(specificValue)]
          })
        }
      }
    
    
      function changeKey(stringInput) {
        let currentKey = parseInt(keys[keyValue.innerText]);
        let newKey = currentKey;
        if (stringInput == 'down') {
          newKey = currentKey - 1;
          if (newKey == -1) {
            newKey = 11
          }
        }
        else if (stringInput == 'up') {
          newKey = currentKey + 1;
          if (currentKey == 11) {
            newKey = 0
          }
        } else {
          newKey = keys[stringInput];
        }
        
        if (keyFlat.value == true || keyFlat.getAttribute('checked') == true) {
          keyValue.innerText = keysFlat[newKey];
        } else {
          keyValue.innerText = keysSharp[newKey];
        }
        renderChords(newKey)
      };
    
      
      setKey.addEventListener('click', function() {
        changeKey(setKey.innerText)
      })
      
      keyDown.addEventListener('click', function() {
        changeKey('down');
      })
      keyUp.addEventListener('click', function() {
        changeKey('up');
      })
      keyFlat.addEventListener('click', function() {
        if (keyFlat.getAttribute('checked') == 'true') {
          keyFlat.setAttribute('checked', false)
        } else {
          keyFlat.setAttribute('checked', true)
        }
        changeKey(keyValue.innerText);
      })
      
   
    
    
      processText(preProcess, postProcess, keyValue.innerText);
    
  
    
  }  
}  


